import * as planningApi from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./userAbsences.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getUserAbsences(action: actions.GetUserAbsencesAction): SagaIterator {
  try {
    const { uid, year } = action.payload.params
    const unavailabilities = yield call(planningApi.getUserAbsences, {
      uid,
      year,
    })
    yield put(actions.getUserAbsencesSucces(unavailabilities && unavailabilities.data))
  } catch (e) {
    yield put(actions.getUserAbsencesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* userAbsencesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getUserAbsences)
}
